import { Helmet } from "react-helmet-async";

/**
 * Renders site-verification meta tags from environment variables.
 * Mount once at the top of any page (or just Home).
 *
 * Env vars (set in /app/frontend/.env):
 *   REACT_APP_GOOGLE_SITE_VERIFICATION   → content for <meta name="google-site-verification">
 *   REACT_APP_BING_SITE_VERIFICATION     → content for <meta name="msvalidate.01">
 */
export default function SiteVerification() {
  const google = process.env.REACT_APP_GOOGLE_SITE_VERIFICATION;
  const bing = process.env.REACT_APP_BING_SITE_VERIFICATION;
  if (!google && !bing) return null;
  return (
    <Helmet>
      {google && <meta name="google-site-verification" content={google} />}
      {bing && <meta name="msvalidate.01" content={bing} />}
    </Helmet>
  );
}
